import { useNavigate } from 'react-router-dom';

interface ViewDocumentsProps {
  caseId: string;
}

export function ViewDocuments({ caseId }: ViewDocumentsProps) {
  const navigate = useNavigate();

  const handleViewDocuments = () => {
    // Navigate to the documents page for this case
    navigate(`/cases/${caseId}/documents`);
  };

  return (
    <button 
      onClick={handleViewDocuments}
      className="flex items-center gap-1 text-blue-600 hover:text-blue-800 px-2 py-1 rounded-md hover:bg-blue-50"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
      <span>Documents</span>
    </button>
  );
}
